
// Load Styles
import '../scss/main.scss';
import $ from "jquery";
window.jQuery = $
window.$ = $
import "@fancyapps/ui/dist/fancybox.css";
import {Fancybox} from "@fancyapps/ui";







// Load Bootstrap JS
window.bootstrap = require('bootstrap')
require('@popperjs/core')

// App code

require('parsleyjs')
// window.Parsley = require('parsleyjs')


$(document).on('click', '#toggle-mobile-nav', function () {
    $('body').toggleClass('mobile-nav-open')
})


$(document).on('click', '.dropdown-nav-item > a', function (e) {
    let parent = $(this).parent('.dropdown-nav-item')

    $('.dropdown-nav-item').not(parent).removeClass('is-open').find('.sub-menu').hide()

    parent.toggleClass('is-open')
    if (parent.hasClass('is-open')) {
        parent.find('.sub-menu').slideDown(150, 'swing')
    } else {
        parent.find('.sub-menu').slideUp(150, 'swing')
    }
    e.preventDefault()
    return false
})

$(document).on('click', function () {
    $('.dropdown-nav-item.is-open > a').trigger('click')
})


$("#newsletter-form").on('submit', function (e) {
    e.preventDefault();
    let form = $(this);

    form.parsley().validate();

    if (form.parsley().isValid()) {


        let button = $(this).find('button')
        let alert = $(this).find('.alert')
        button.prop('disabled', true).addClass('disabled').text('Please wait...')

        alert.hide().removeClass('alert-success alert-danger').html('')

        jQuery.ajax({
            type: "POST",
            url: window.wpajaxurl,
            dataType: 'json',
            data: 'action=newsletter_subscribe&' + form.serialize(),
            success: function (data) {
                if (typeof data.data === 'undefined') {
                    alert.addClass('alert-danger').html('An unknown error occurred. Please try again').show()
                }else if(!data.success){
                    alert.addClass('alert-danger').html(data.data).show()
                }else{
                    alert.addClass('alert-success').html(data.data).show()
                    form[0].reset()
                }
                button.prop('disabled', false).removeClass('disabled').text('Submit')
            },
            error:function () {
                alert.addClass('alert-danger').html('An unknown error occurred. Please try again')
                button.prop('disabled', false).removeClass('disabled').text('Submit')
            }
        })

        return false
    }
});














/**
 * Animate elements when they appeat in the viewport
 * @param { IntersectionObserverEntry[] } changes: IntersectionObserver changes
 */
const animonCallback = function(changes) {
    changes.forEach(change => {
        let target = change.target;
        let delay = parseInt(target.getAttribute('data-delay')) || 0;
        let duration = target.getAttribute('data-duration') || null;
        if (change.intersectionRatio > 0) {
            setTimeout(() => {
                if (duration) {
                    target.style.transitionDuration = `${duration}, ${duration}`;
                }
                target.classList.add('is-visible');
            }, delay);
        } else {
            /**
             * Only animate once
             */
            // target.classList.remove('is-visible');
            // target.style.removeProperty('transition-duration');
        }
    });
};


/**
 * Create a new IntersectionObserver object
 * @param { Function } animonCallback: function to be executed
 */
const observer = new IntersectionObserver(animonCallback);


/**
 * Animon's initialisation
 * @param { String } selector: items that should be animated
 */
window.animon = (selector = '.animonItem') => {
    // Build our nodes list
    const nodes = document.querySelectorAll(selector);

    // If IntersectionObserver is supported
    if ('IntersectionObserver' in window) {
        // Observe each node
        nodes.forEach((node) => {
            observer.observe(node);
        });
    } else {
        // Else make every node visible
        nodes.forEach((node) => node.classList.add('is-visible'));
    }
};


